import React from 'react'
import { buildQuery } from './graphql'
import type { InlineInputProps } from '../InlineInput';
import { InlineInput } from '../InlineInput'
import { useRole } from '@ztechapps/common.hook'
import type { SetOptional } from 'type-fest'

const defaultMutationConfig = buildQuery('value').updateConfig

export type AppSettingInlineInputProps = {
  roleName?: string
} & SetOptional<InlineInputProps, 'mutationConfig' | 'name' | 'canEdit'>

/**
 *  The default inline input for appSetting. It is ideal primitive type value (e.g. string, number),
 *  But for other types, like array, objects, the  user needs to provide the editContent and displayContent
 */
export const AppSettingInlineInput = ({
  roleName = 'setting.canEdit',
  name = 'value',
  canEdit = true,
  parentInputComponent,
  ...rest
}: AppSettingInlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput
  const { hasRole } = useRole({ roleName })
  canEdit = hasRole && canEdit
  return <ParentInput {...{ ...rest, name, mutationConfig: defaultMutationConfig, hasRole, canEdit }} />
}
